<template>
  <div class="login-card__name-card">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.preferences.header') }}</h1>
      <p class="login-card__title-desc"> {{ trans.get('auth.card.preferences.subheader') }}</p>
    </div>
    <div>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-row">
            <div class="form-group col-12">
              <ValidationProvider name="preferences" rules="required|min:1" v-slot="{ errors }" mode="eager">
                <PreferencesChooseComponent v-model="userPreferences" :preferences="preferences"></PreferencesChooseComponent>

                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <p class="login-card__desc">{{ trans.get('auth.card.preferences.description') }}</p>
            </div>
          </div>
          <button type="submit" class="button button__fill button--w-100 mt-4 text--smedium">{{ trans.get('auth.card.preferences.continue') }}</button>
        </form>
      </ValidationObserver>
      <button type="button" class="button button__link button__link--underline mt-3 text--smedium" @click="goBack">
        {{ trans.get('auth.card.buttons.back') }}
      </button>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import PreferencesChooseComponent from '../../../front/components/User/PreferencesChooseComponent.vue';
import AuthGoBackMixin from '../../../front/components/Auth/AuthGoBackMixin';

export default {
  mixins: [AuthGoBackMixin],
  components: { PreferencesChooseComponent, ValidationObserver, ValidationProvider },
  props: ['swapComponent', 'form'],
  data: () => ({
    preferences: [],
    userPreferences: [],
  }),
  methods: {
    loadData: function () {
      axios // get user preferences
        .get(zRoute('ajax.user.preferences.index'))
        .then((response) => {
          this.userPreferences = response.data.data.map((x) => x.id);
        });
    },
    onSubmit() {
      if (this.form.id) {
        axios
          .post(zRoute('ajax.user.preferences.update'), {
            preferences: this.userPreferences,
          })
          .then((response) => {
            this.swapComponent('auth-name-email-last-card');
          })
          .catch((error) => {
            const errors = error.response.data.errors;

            if (error.response.status === 422) {
              this.$refs.form.setErrors(errors);
            }
          });
      } else {
        this.form.preferences = this.userPreferences;
        this.swapComponent('auth-name-email-last-card');
      }
    },
    goBack() {
      this.swapComponent('auth-gender-card');
    }
  },
  mounted() {
    this.loadData();
  },
  activated() {
    this.$refs.form.reset();
    this.$emit('update:progress', 80);
    this.$emit('update:step', 4);
  },
};
</script>
<style scoped>
</style>
